export enum LocalStorageKey {
  RedirectUrl = 'redirectUrl',
  CompartmentId = 'compartmentId',
}
